import { CheckCircleIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Heading,
  HStack,
  IconButton,
  Tooltip,
  useColorModeValue,
  useToast,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";

const AssignedChecklists = ({
  assignedChecklists,
  job,
  setActiveChecklist,
  setChecklistModalOpen,
  setAssignedChecklists,
}) => {
  const toast = useToast();
  const mode = useColorModeValue;
  const gray200600 = mode("gray.200", "gray.600");

  if (!assignedChecklists.length) return null;

  return (
    <Box>
      <Heading size='sm' mb={3}>
        Assigned Checklists
      </Heading>
      <VStack spacing={3} align='stretch'>
        {assignedChecklists.map((checklist) => (
          <HStack
            key={checklist._id}
            p={3}
            borderWidth='1px'
            borderRadius='md'
            borderColor={gray200600}
            justify='space-between'
          >
            {(() => {
              // Robust check for filled: responses (array), responses (object), or response (singular)
              const hasFilled =
                (Array.isArray(checklist.responses) && checklist.responses.length > 0) ||
                (checklist.responses &&
                  typeof checklist.responses === "object" &&
                  Object.keys(checklist.responses).length > 0) ||
                !!checklist.response;
              return (
                <Button
                  flex={1}
                  colorScheme={hasFilled ? "green" : "gray"}
                  variant={hasFilled ? "solid" : "outline"}
                  leftIcon={
                    hasFilled ? (
                      <Tooltip label='Checklist filled' hasArrow>
                        <span>
                          <CheckCircleIcon color='green.400' />
                        </span>
                      </Tooltip>
                    ) : null
                  }
                  onClick={() => {
                    setActiveChecklist(checklist);
                    setChecklistModalOpen(true);
                  }}
                >
                  {checklist.checklistName}
                </Button>
              );
            })()}
            <IconButton
              icon={<DeleteIcon />}
              colorScheme='red'
              variant='ghost'
              aria-label='Delete checklist'
              onClick={async () => {
                if (window.confirm(`Are you sure you want to un-assign "${checklist.checklistName}"?`)) {
                  try {
                    await axios.delete(`/api/checklists/${checklist._id}`);
                    toast({
                      title: "Success",
                      description: "Checklist un-assigned successfully",
                      status: "success",
                      duration: 3000,
                    });
                    // Refresh assigned checklists
                    const { data } = await axios.get(`/api/checklists/job/${job.JOB_NO}`);
                    setAssignedChecklists(data.checklists || []);
                  } catch (error) {
                    toast({
                      title: "Error",
                      description: "Failed to un-assign checklist",
                      status: "error",
                      duration: 3000,
                    });
                  }
                }
              }}
            />
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};

export default AssignedChecklists;
